import React from "react";

export const CarouselButtonLeftSVG = ({}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      {/* Background circle */}
      <g filter="url(#filter0_d_10_379)">
        <circle cx="22" cy="22" r="18" fill="white" />
      </g>
      {/* Left arrow path */}
      <path
        d="M11.485 13.458C11.5451 13.3944 11.5921 13.3195 11.6234 13.2377C11.6546 13.1559 11.6694 13.0687 11.6669 12.9812C11.6644 12.8936 11.6447 12.8074 11.6089 12.7275C11.5731 12.6476 11.522 12.5755 11.4583 12.5153C11.3947 12.4552 11.3198 12.4082 11.238 12.377C11.1562 12.3458 11.069 12.331 10.9815 12.3334C10.8939 12.3359 10.8077 12.3556 10.7278 12.3914C10.6479 12.4272 10.5758 12.4784 10.5156 12.542L4.84898 18.542C4.73195 18.6658 4.66675 18.8297 4.66675 19C4.66675 19.1703 4.73195 19.3342 4.84898 19.458L10.5156 25.4587C10.5754 25.5237 10.6475 25.5762 10.7277 25.6132C10.8079 25.6501 10.8947 25.6708 10.9829 25.6739C11.0712 25.6771 11.1592 25.6626 11.2418 25.6315C11.3245 25.6003 11.4001 25.553 11.4643 25.4924C11.5285 25.4317 11.58 25.359 11.6159 25.2782C11.6517 25.1975 11.6712 25.1105 11.6731 25.0222C11.675 24.9339 11.6594 24.8461 11.6271 24.7639C11.5948 24.6817 11.5465 24.6067 11.485 24.5433L6.25031 19L11.485 13.458Z"
        fill="#586675"
        transform="translate(12, 3)" // Added transformation to center the arrow
      />
      <defs>
        <filter id="filter0_d_10_379" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.552941 0 0 0 0 0.690196 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10_379" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10_379" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const CarouselButtonRightSVG = ({}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      {/* Background circle */}
      <g filter="url(#filter0_d_10_379)">
        <circle cx="22" cy="22" r="18" fill="white" />
      </g>
      {/* Right arrow path */}
      <path
        d="M2.51502 13.458C2.45488 13.3944 2.40786 13.3195 2.37665 13.2377C2.34544 13.1559 2.33065 13.0687 2.33312 12.9812C2.3356 12.8936 2.35529 12.8074 2.39108 12.7275C2.42687 12.6476 2.47804 12.5755 2.54169 12.5153C2.60534 12.4552 2.68021 12.4082 2.76203 12.377C2.84385 12.3458 2.93101 12.331 3.01855 12.3334C3.10608 12.3359 3.19227 12.3556 3.27219 12.3914C3.35212 12.4272 3.42421 12.4784 3.48436 12.542L9.151 18.542C9.268 18.6658 9.33333 18.8297 9.33333 19C9.33333 19.1703 9.268 19.3342 9.151 19.458L3.48436 25.4587C3.42461 25.5237 3.35253 25.5762 3.27231 25.6132C3.1921 25.6501 3.10534 25.6708 3.01707 25.6739C2.92881 25.6771 2.8408 25.6626 2.75817 25.6315C2.67553 25.6003 2.59991 25.553 2.53569 25.4924C2.47148 25.4317 2.41995 25.359 2.38411 25.2782C2.34826 25.1975 2.32882 25.1105 2.32689 25.0222C2.32497 24.9339 2.34061 24.8461 2.37291 24.7639C2.4052 24.6817 2.45351 24.6067 2.51502 24.5433L7.74969 19L2.51502 13.458Z"
        fill="#586675"
        transform="translate(20, 3)" // Added transformation to center the arrow
      />
      <defs>
        <filter id="filter0_d_10_379" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.552941 0 0 0 0 0.690196 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10_379" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10_379" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const AddServiceCircleSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
    <g filter="url(#filter0_d_28_232)">
      <circle cx="30" cy="26" r="26" fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_28_232" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.552941 0 0 0 0 0.690196 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28_232" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_28_232" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const AddServiceIconSvg = () => (
  <svg className="dashboard-add-service-icon-svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M10.9618 1.83591C9.76063 2.02634 8.64247 2.38767 7.59266 2.92478C6.26454 3.60349 4.86317 4.71677 4.65809 5.25388C4.4286 5.85935 4.84364 6.52829 5.48817 6.58201C5.86903 6.6113 6.04969 6.53318 6.5038 6.12302C8.39344 4.40915 10.6249 3.61326 13.0858 3.76462C15.0878 3.89158 16.9091 4.68259 18.496 6.12302C18.9501 6.53318 19.1307 6.6113 19.5116 6.58201C19.9901 6.54294 20.3417 6.1865 20.4003 5.68357C20.4345 5.34177 20.3124 5.08787 19.9071 4.69236C18.4716 3.28611 16.5282 2.29978 14.4042 1.89939C13.6474 1.75779 11.7089 1.72361 10.9618 1.83591Z"
      fill="#6B96C1"
    />
    <path
      d="M11.3525 5.74216C10.0732 5.95701 8.79883 6.57712 7.88574 7.43161C7.46094 7.82712 7.37305 7.98826 7.37305 8.35935C7.37305 8.71091 7.52441 9.00876 7.79785 9.17966C8.2666 9.47751 8.66699 9.41892 9.16504 8.97458C9.81934 8.39353 10.5029 8.01755 11.2793 7.80271C11.6357 7.70505 11.8066 7.6904 12.5 7.6904C13.1885 7.6904 13.3643 7.70505 13.7158 7.80271C14.4922 8.01755 15.0879 8.33982 15.7617 8.92087C16.3477 9.4238 16.7188 9.48728 17.2021 9.17966C17.4756 9.00876 17.627 8.71091 17.627 8.35447C17.627 7.99802 17.5244 7.81736 17.1045 7.42185C16.1816 6.56247 14.9072 5.94724 13.5986 5.73728C13.0566 5.64939 11.8848 5.64939 11.3525 5.74216Z"
      fill="#6B96C1"
    />
    <path
      d="M11.8799 9.63866C11.3867 9.79979 10.9521 10.1904 10.7031 10.6933C10.5811 10.9375 10.5713 11.0107 10.5713 11.5234C10.5713 12.0361 10.5811 12.1094 10.7031 12.3535C10.9521 12.8564 11.3916 13.2519 11.8799 13.4033C12.0557 13.4619 11.5674 13.4717 8.58398 13.4717C5.78613 13.4766 5.01465 13.4912 4.72656 13.5449C3.23242 13.833 1.94336 14.8193 1.26953 16.1816C0.883789 16.9629 0.805664 17.3389 0.805664 18.3594C0.805664 19.3799 0.883789 19.7558 1.26953 20.5371C1.95801 21.9336 3.33496 22.9541 4.83887 23.1933C5.10254 23.2324 7.18262 23.2422 12.7197 23.2324L20.2393 23.2178L20.6299 23.1055C21.5869 22.832 22.5293 22.207 23.1543 21.4355C23.54 20.957 23.9258 20.2197 24.0771 19.6533C24.209 19.1553 24.2578 18.081 24.1699 17.5439C23.8477 15.5273 22.2217 13.8867 20.1953 13.5303C20.0098 13.4961 18.6328 13.4766 16.4111 13.4766C12.9834 13.4717 12.9199 13.4717 13.1689 13.3838C13.6572 13.2178 14.0479 12.8613 14.2969 12.3535C14.4189 12.1094 14.4287 12.0361 14.4287 11.5234C14.4287 11.001 14.4189 10.9424 14.2871 10.6689C14.1016 10.293 13.7305 9.92186 13.3545 9.7412C13.1006 9.61424 13.0029 9.59471 12.5732 9.58495C12.2607 9.57518 12.0117 9.59471 11.8799 9.63866ZM7.03125 17.5049C7.39258 17.6855 7.56836 17.9639 7.56836 18.3594C7.56836 18.7451 7.40234 19.0234 7.05566 19.209C6.87988 19.3017 6.78223 19.3115 6.15234 19.3115C5.52246 19.3115 5.4248 19.3017 5.24902 19.209C5.1416 19.1504 5.01953 19.0625 4.97559 19.0137C4.5752 18.5547 4.6875 17.8076 5.2002 17.5391C5.43945 17.417 5.6543 17.3877 6.27441 17.4023C6.71875 17.4121 6.89941 17.4365 7.03125 17.5049ZM11.9141 17.5049C12.2754 17.6855 12.4512 17.9639 12.4512 18.3594C12.4512 18.7451 12.2852 19.0234 11.9385 19.209C11.7627 19.3017 11.665 19.3115 11.0352 19.3115C10.4053 19.3115 10.3076 19.3017 10.1318 19.209C10.0244 19.1504 9.90234 19.0625 9.8584 19.0137C9.45801 18.5547 9.57031 17.8076 10.083 17.5391C10.3223 17.417 10.5371 17.3877 11.1572 17.4023C11.6016 17.4121 11.7822 17.4365 11.9141 17.5049Z"
      fill="#6B96C1"
    />
  </svg>
);

export const InviteIconSvg = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="128" height="127" viewBox="0 0 128 127" fill="none">
    <g mask="url(#mask0_28_237)">
      <path
        d="M66.2646 113.286C96.3198 113.286 120.684 88.9214 120.684 58.8661C120.684 28.8109 96.3198 4.44635 66.2646 4.44635C36.2094 4.44635 11.8447 28.8109 11.8447 58.8661C11.8447 88.9214 36.2094 113.286 66.2646 113.286Z"
        stroke="white"
        strokeWidth="0.351414"
        stroke-miterlimit="10"
      />
      <path
        d="M21.9931 28.8292C23.0517 28.8292 23.9099 27.971 23.9099 26.9123C23.9099 25.8537 23.0517 24.9957 21.9931 24.9957C20.9346 24.9957 20.0764 25.8537 20.0764 26.9123C20.0764 27.971 20.9346 28.8292 21.9931 28.8292Z"
        fill="#6BC2B4"
      />
      <path
        d="M120.684 62.8554C121.743 62.8554 122.602 61.9974 122.602 60.9387C122.602 59.8801 121.743 59.0219 120.684 59.0219C119.626 59.0219 118.768 59.8801 118.768 60.9387C118.768 61.9974 119.626 62.8554 120.684 62.8554Z"
        fill="#7674C2"
      />
      <path
        d="M68.4969 115.203C69.5554 115.203 70.4136 114.344 70.4136 113.286C70.4136 112.227 69.5554 111.369 68.4969 111.369C67.4383 111.369 66.5801 112.227 66.5801 113.286C66.5801 114.344 67.4383 115.203 68.4969 115.203Z"
        fill="#32567A"
      />
      <path
        d="M67.5255 99.8203C89.9459 99.8203 108.121 81.645 108.121 59.2246C108.121 36.804 89.9459 18.6288 67.5255 18.6288C45.105 18.6288 26.9297 36.804 26.9297 59.2246C26.9297 81.645 45.105 99.8203 67.5255 99.8203Z"
        stroke="white"
        strokeWidth="0.262147"
        stroke-miterlimit="10"
      />
      <path
        d="M107.425 68.8317C108.215 68.8317 108.855 68.1916 108.855 67.402C108.855 66.6122 108.215 65.972 107.425 65.972C106.636 65.972 105.995 66.6122 105.995 67.402C105.995 68.1916 106.636 68.8317 107.425 68.8317Z"
        fill="#6BC2B4"
      />
      <path
        d="M29.8736 75.9104C30.6634 75.9104 31.3035 75.2702 31.3035 74.4805C31.3035 73.6909 30.6634 73.0507 29.8736 73.0507C29.084 73.0507 28.4438 73.6909 28.4438 74.4805C28.4438 75.2702 29.084 75.9104 29.8736 75.9104Z"
        fill="#7674C2"
      />
      <path
        d="M49.3414 24.3209C50.1311 24.3209 50.7713 23.6807 50.7713 22.8909C50.7713 22.1013 50.1311 21.4612 49.3414 21.4612C48.5518 21.4612 47.9116 22.1013 47.9116 22.8909C47.9116 23.6807 48.5518 24.3209 49.3414 24.3209Z"
        fill="#32567A"
      />
      <path
        d="M88.6539 104.179H41.7722C39.7382 104.179 38.2479 102.53 38.4435 100.496L46.4466 17.2421C46.642 15.2081 48.4493 13.5593 50.4832 13.5593H97.3649C99.3989 13.5593 100.889 15.2081 100.694 17.2421L92.6906 100.496C92.4951 102.53 90.6877 104.179 88.6539 104.179Z"
        fill="#32567A"
      />
      <path
        d="M85.3499 104.179H38.4682C36.4344 104.179 34.9441 102.53 35.1395 100.496L43.1426 17.2421C43.3382 15.2081 45.1454 13.5593 47.1794 13.5593H94.0611C96.0949 13.5593 97.5852 15.2081 97.3898 17.2421L89.3867 100.496C89.1912 102.53 87.3839 104.179 85.3499 104.179Z"
        fill="url(#paint0_linear_28_237)"
      />
      <path
        d="M83.5732 101.411H40.777C38.892 101.411 37.5108 99.8834 37.692 97.9985L45.2148 19.74C45.3961 17.855 47.071 16.3271 48.9559 16.3271H91.7521C93.6371 16.3271 95.0183 17.855 94.8371 19.74L87.3143 97.9985C87.133 99.8834 85.4582 101.411 83.5732 101.411Z"
        fill="white"
      />
      <path
        d="M87.0054 51.9279L41.0959 51.8871C40.9084 51.8923 40.7219 51.8572 40.549 51.7846C40.3761 51.7119 40.2206 51.6031 40.0932 51.4655C39.9656 51.328 39.8689 51.1647 39.8094 50.9869C39.7499 50.8089 39.7292 50.6203 39.7484 50.4337L42.2235 22.9508C42.2682 22.5542 42.4567 22.1877 42.7532 21.9205C43.0495 21.6532 43.4334 21.5037 43.8324 21.4999L89.7419 21.5408C89.9294 21.5357 90.1159 21.5706 90.2888 21.6433C90.4617 21.7162 90.6172 21.8248 90.7446 21.9624C90.8723 22.1 90.9689 22.2631 91.0284 22.4411C91.0879 22.619 91.1086 22.8076 91.0894 22.9942L88.6143 50.4772C88.5696 50.8737 88.3811 51.2401 88.0846 51.5075C87.7883 51.7747 87.4044 51.9243 87.0054 51.9279Z"
        fill="url(#paint1_linear_28_237)"
      />
      <path
        d="M85.5599 81.5413H66.1557C66.0126 81.5442 65.8705 81.5161 65.7391 81.4594C65.6077 81.4026 65.4901 81.3182 65.394 81.212C65.2981 81.1058 65.2261 80.9803 65.1828 80.8438C65.1394 80.7074 65.1261 80.5632 65.1432 80.4212L67.4993 55.9112C67.5333 55.6073 67.6765 55.3261 67.9025 55.12C68.1284 54.914 68.4214 54.7972 68.7271 54.7911H88.1314C88.2745 54.7882 88.4165 54.8161 88.5479 54.873C88.6793 54.9298 88.7969 55.0141 88.8929 55.1204C88.989 55.2266 89.0611 55.352 89.1043 55.4885C89.1475 55.625 89.161 55.7692 89.1437 55.9112L86.7877 80.4212C86.7537 80.725 86.6104 81.0061 86.3845 81.2122C86.1587 81.4182 85.8656 81.5352 85.5599 81.5413Z"
        fill="url(#paint2_linear_28_237)"
      />
      <path
        d="M80.9337 68.0202C83.1221 65.9346 83.3602 62.6323 81.4657 60.6447C79.571 58.6568 76.2613 58.7362 74.0731 60.8217C71.8848 62.9074 71.6466 66.2095 73.5412 68.1974C75.4358 70.1852 78.7455 70.1059 80.9337 68.0202Z"
        stroke="#6B96C1"
        strokeWidth="2.14348"
        stroke-miterlimit="10"
      />
      <path
        d="M75.0436 69.2422C73.2283 68.4583 72.0777 66.5949 72.2866 64.4209C72.5635 61.5397 75.1237 59.2041 78.0049 59.2041"
        stroke="white"
        strokeWidth="2.14348"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path d="M74.6128 73.7268H78.6048" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M74.1782 78.2479H78.1704" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path opacity="0.4" d="M72.2688 75.9617H80.519" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path
        d="M61.8296 81.5413H42.4255C42.2824 81.5442 42.1402 81.5161 42.0088 81.4594C41.8776 81.4026 41.7599 81.3182 41.6638 81.212C41.5679 81.1058 41.4958 80.9803 41.4526 80.8438C41.4092 80.7074 41.3959 80.5632 41.413 80.4212L43.7691 55.9112C43.8031 55.6073 43.9463 55.3261 44.1722 55.12C44.3982 54.914 44.6912 54.7972 44.9969 54.7911H64.4012C64.5443 54.7882 64.6863 54.8161 64.8177 54.873C64.9491 54.9298 65.0667 55.0141 65.1627 55.1204C65.2588 55.2266 65.3308 55.352 65.3741 55.4885C65.4173 55.625 65.4308 55.7692 65.4135 55.9112L63.0574 80.4212C63.0235 80.725 62.8802 81.0061 62.6543 81.2122C62.4285 81.4182 62.1354 81.5352 61.8296 81.5413Z"
        fill="#6B96C1"
      />
      <path
        d="M57.2036 68.0202C59.3919 65.9346 59.6299 62.6323 57.7354 60.6447C55.8409 58.6568 52.531 58.7362 50.3428 60.8217C48.1545 62.9074 47.9164 66.2095 49.811 68.1974C51.7055 70.1852 55.0153 70.1059 57.2036 68.0202Z"
        stroke="#32567A"
        strokeWidth="2.14348"
        stroke-miterlimit="10"
      />
      <path
        d="M58.99 64.4209C58.7131 67.3021 56.153 69.6377 53.2718 69.6377C50.3905 69.6377 48.2794 67.3021 48.5564 64.4209C48.8333 61.5397 51.3935 59.2041 54.2747 59.2041"
        stroke="white"
        strokeWidth="2.14348"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path d="M50.8826 73.7268H54.8746" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M50.448 78.2479H54.4402" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path opacity="0.4" d="M48.5388 75.9617H56.789" stroke="white" strokeWidth="1.0972" stroke-miterlimit="10" strokeLinecap="round" />
      <path
        d="M83.9333 99.0719H40.6817C40.5461 99.0745 40.4115 99.0481 40.2871 98.9943C40.1625 98.9404 40.051 98.8604 39.9599 98.7598C39.869 98.6592 39.8008 98.5403 39.7596 98.4108C39.7187 98.2816 39.7059 98.145 39.7222 98.0103L41.0129 84.5842C41.0451 84.2962 41.1809 84.0296 41.395 83.8343C41.6091 83.6391 41.8868 83.5283 42.1766 83.5225H85.428C85.5636 83.5198 85.6982 83.5464 85.8228 83.6002C85.9472 83.6541 86.0587 83.7339 86.1498 83.8346C86.2407 83.9352 86.3089 84.0542 86.35 84.1835C86.391 84.3129 86.4038 84.4495 86.3875 84.5842L85.0969 98.0103C85.0646 98.2983 84.9289 98.5647 84.7148 98.76C84.5008 98.9554 84.2229 99.0662 83.9333 99.0719Z"
        fill="url(#paint3_linear_28_237)"
      />
      <path d="M43.6936 95.9589L44.3037 89.6117" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M48.1703 91.5125L47.7429 95.9588" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M52.0739 93.0311L51.7925 95.9589" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M56.6105 87.9622L55.8418 95.9588" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M60.1728 93.0311L59.8914 95.9589" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M64.6755 88.3153L63.9407 95.9588" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M68.2951 92.7853L67.99 95.9589" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M72.2021 94.2682L72.0396 95.9588" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M76.699 89.6117L76.0889 95.9589" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M80.9806 87.1949L80.1382 95.9589" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path
        d="M44.8145 47.7137L47.2452 51.5214C47.3549 51.6933 47.3923 51.9015 47.3492 52.1007C47.3059 52.3001 47.1859 52.4741 47.0149 52.5853L46.6221 52.8405C45.9645 53.2678 45.1741 53.4418 44.3979 53.3303C43.6216 53.2186 42.9123 52.829 42.4017 52.2336L39.176 48.472L44.8145 47.7137Z"
        fill="#FFCCB3"
      />
      <path d="M42.9597 49.179C42.9597 49.179 43.8598 52.2694 45.668 53.2608C46.1374 53.0791 46.5885 52.8528 47.0149 52.5853L44.9873 49.179" fill="#FDAD8C" />
      <path
        d="M1.37524 63.0769L10.9229 58.5014C11.8225 58.0704 12.5832 57.3955 13.1185 56.5537L22.3419 42.0445C22.9161 41.1413 23.7489 40.4316 24.732 40.0081L38.0165 34.2849L35.1724 55.7926L35.1224 56.587C35.1224 56.587 31.6087 65.6873 22.9968 68.9933L9.22794 77.4149L1.37524 63.0769Z"
        fill="#FFCCB3"
      />
      <path
        d="M11.7657 57.9966C11.7657 57.9966 16.2821 69.2697 22.9968 68.9934L18.7097 71.6156C18.7097 71.6156 4.1582 68.9163 9.6052 59.1107L11.7657 57.9966Z"
        fill="#FDAD8C"
      />
      <path d="M35.9601 38.2653C35.9601 38.2653 31.2631 41.1114 31.5123 47.7137L37.1529 45.6059L35.9601 38.2653Z" fill="#FDAD8C" />
      <path
        d="M47.7594 47.7137L50.1902 51.5214C50.2999 51.6933 50.3372 51.9015 50.2941 52.1007C50.251 52.3001 50.1308 52.4741 49.9598 52.5853L49.567 52.8405C48.9094 53.2678 48.119 53.4418 47.3428 53.3303C46.5665 53.2186 45.8572 52.829 45.3466 52.2336L42.1211 48.472L47.7594 47.7137Z"
        fill="#FFCCB3"
      />
      <path
        d="M83.6943 49.2152L37.7849 49.1744C37.5974 49.1794 37.4109 49.1445 37.2381 49.0717C37.0651 48.999 36.9097 48.8902 36.7821 48.7527C36.6545 48.6151 36.5579 48.452 36.4984 48.274C36.4389 48.096 36.4181 47.9076 36.4374 47.721L38.9124 20.2379C38.9573 19.8413 39.1456 19.4748 39.4421 19.2076C39.7385 18.9404 40.1223 18.7908 40.5215 18.787L86.4308 18.828C86.6184 18.8229 86.8048 18.8579 86.9778 18.9306C87.1506 19.0033 87.3061 19.1121 87.4336 19.2495C87.5612 19.3871 87.6579 19.5504 87.7173 19.7282C87.7768 19.9062 87.7976 20.0948 87.7785 20.2813L85.3034 47.7644C85.2585 48.161 85.0701 48.5274 84.7738 48.7946C84.4773 49.0618 84.0934 49.2114 83.6943 49.2152Z"
        fill="#32567A"
      />
      <path
        d="M27.2065 49.0789L33.0958 46.4848L39.1185 42.3736C40.7024 41.2925 44.0102 40.8055 45.2009 42.3085C46.4122 43.8373 45.0516 46.8617 43.5826 48.1445L38.0166 53.0049L35.1224 56.587L27.2065 49.0789Z"
        fill="#FFCCB3"
      />
      <path
        d="M39.176 43.9348C39.176 43.9348 39.9711 47.0007 42.0325 47.5311L44.219 45.6839C44.4406 45.5188 44.6264 45.3104 44.7649 45.0712C44.9034 44.832 44.9917 44.567 45.0245 44.2927C45.0573 44.0182 45.0339 43.74 44.9556 43.4749C44.8773 43.2098 44.7459 42.9634 44.5693 42.7508C44.2608 42.3794 43.8305 42.1296 43.355 42.0462C42.8795 41.9629 42.3897 42.0512 41.9733 42.2955L39.176 43.9348Z"
        stroke="#FF967C"
        strokeWidth="0.55009"
        strokeLinecap="round"
      />
      <path
        d="M11.2858 58.1224C11.2858 58.1224 10.1444 66.2848 20.0764 70.9586C20.0764 70.9586 12.9417 77.5034 10.191 78.6039C7.44043 79.7042 -2.89443 68.4584 0.781407 62.0753C1.81227 60.2854 11.2858 58.1224 11.2858 58.1224Z"
        fill="#32567A"
      />
      <path d="M48.918 49.5288C48.918 49.5288 45.0469 49.6077 43.6994 50.3129L42.7268 49.1787L48.6947 49.1789L48.918 49.5288Z" fill="#FDAD8C" />
      <path
        d="M120.195 49.2152H92.6706C90.5972 49.2152 89.0652 47.5343 89.2488 45.4609L92.9418 3.75413C93.1254 1.68088 94.955 0 97.0284 0H124.553C126.627 0 128.158 1.68088 127.975 3.75413L124.282 45.4609C124.098 47.5343 122.268 49.2152 120.195 49.2152Z"
        fill="#6BC2B4"
      />
      <path
        d="M116.255 23.55C120.614 19.3803 121.053 12.7662 117.236 8.77703C113.42 4.78787 106.793 4.93414 102.435 9.10386C98.0762 13.2736 97.6368 19.8877 101.453 23.8769C105.27 27.8662 111.897 27.7198 116.255 23.55Z"
        fill="white"
      />
      <path d="M109.928 16.6517L116.838 22.9534C116.838 22.9534 118.41 21.2638 118.878 20.0564L109.928 16.6517Z" fill="url(#paint4_linear_28_237)" />
      <path
        d="M110.388 4.54626L109.406 15.6343C109.384 15.8363 109.422 16.0402 109.515 16.2211C109.608 16.4018 109.751 16.5514 109.928 16.6515L119.303 21.8708C119.303 21.8708 124.87 6.33973 110.388 4.54626Z"
        fill="#32567A"
      />
      <path d="M95.7141 34.4534H107.117" stroke="white" strokeWidth="2.20036" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M94.8794 43.8807H106.282" stroke="white" strokeWidth="2.20036" stroke-miterlimit="10" strokeLinecap="round" />
      <path opacity="0.4" d="M95.3015 39.1139H118.866" stroke="white" strokeWidth="2.20036" stroke-miterlimit="10" strokeLinecap="round" />
      <path
        d="M86.3447 79.9403C86.3447 79.9403 90.0204 78.96 91.9767 81.0664C91.9767 81.0664 95.4929 80.428 96.9225 82.3841C96.9225 82.3841 100.04 82.5646 100.943 83.8361C101.693 83.9398 102.403 84.2404 103 84.7075C103.597 85.1746 104.059 85.7915 104.34 86.4954C105.193 88.5045 104.47 100.12 103.622 104.282C103.411 105.323 103.483 106.402 103.832 107.405L105.988 113.598L91.076 119.832L87.5358 110.598C87.5358 110.598 83.2265 103.673 82.6108 102.442C81.9952 101.211 83.0386 90.9941 80.937 84.6118L86.3447 79.9403Z"
        fill="#FFCCB3"
      />
      <path
        d="M89.4592 115.615L89.0291 114.493C89.0291 114.493 96.7666 113.998 103.833 107.405L104.508 109.347C104.508 109.347 103.636 113.359 99.6621 115.249C95.6884 117.14 89.4592 115.615 89.4592 115.615Z"
        fill="#FDAD8C"
      />
      <path
        d="M89.4591 115.615C89.4591 115.615 98.825 116.468 104.508 109.347C104.508 109.347 106.607 110.447 109.829 118.501C110.818 120.975 94.2933 129.782 91.6215 126.121C91.6215 126.121 89.3148 121.242 89.4591 115.615Z"
        fill="#32567A"
      />
      <path
        d="M81.8536 88.4645C81.8536 88.4645 81.5306 90.1785 80.0031 90.1786C79.0065 90.1786 74.6869 88.8736 71.8037 87.9662C71.0192 87.7194 70.1778 87.7194 69.3933 87.9662C68.6089 88.2131 67.9191 88.695 67.4175 89.3465L67.2422 89.5741C67.1551 89.6869 67.092 89.8161 67.0563 89.9542C67.0207 90.0921 67.0136 90.2358 67.0351 90.3766C67.0566 90.5174 67.1066 90.6525 67.1818 90.7734C67.2571 90.8945 67.3562 90.9989 67.473 91.0804C69.9139 92.7844 76.5052 97.4095 77.3483 98.2525C78.3858 99.2899 84.163 105.106 84.163 105.106L81.8536 88.4645Z"
        fill="#FFCCB3"
      />
      <path
        d="M81.5028 86.7473C81.5028 86.7473 84.625 90.9733 84.1628 91.8984C83.7007 92.8235 78.8594 89.9951 78.8594 89.9951C78.8594 89.9951 82.766 91 81.5028 86.7473Z"
        fill="#FDAD8C"
      />
      <path
        d="M80.9371 84.6118L75.6834 68.6576C75.5033 68.1103 75.4347 67.5324 75.4821 66.9581C75.5294 66.3839 75.6916 65.8249 75.959 65.3147C76.2263 64.8042 76.5935 64.3527 77.0385 63.9869C77.4837 63.621 77.9978 63.3482 78.5502 63.1848C79.0025 63.0511 79.4879 63.0872 79.9153 63.2866C80.3428 63.486 80.6825 63.8347 80.8705 64.2671L88.2408 81.2092L80.9371 84.6118Z"
        fill="#FFCCB3"
      />
      <path
        d="M78.6592 77.6932C78.808 77.9378 79.0059 78.149 79.2402 78.3135C79.4746 78.4781 79.7403 78.5923 80.021 78.6494"
        stroke="#FF967C"
        strokeWidth="0.55009"
        strokeLinecap="round"
      />
      <path
        d="M80.5491 69.5257C81.1884 69.2424 81.8935 68.8465 82.1968 68.3845L80.2405 63.7396C80.1986 63.6394 80.136 63.5495 80.0566 63.4754C79.9772 63.4014 79.8832 63.3451 79.7804 63.3102C79.6777 63.2753 79.5688 63.2627 79.4608 63.2732C79.3527 63.2836 79.2482 63.3169 79.1541 63.3707C78.458 63.7725 77.5391 64.4975 77.5034 65.5384L78.8265 68.8309C78.8915 68.9918 78.9881 69.1377 79.1107 69.2603C79.2333 69.3829 79.3794 69.4796 79.5401 69.5444C79.7009 69.6093 79.8732 69.641 80.0466 69.6378C80.2199 69.6346 80.3909 69.5964 80.5491 69.5257Z"
        stroke="#FF967C"
        strokeWidth="0.55009"
        strokeLinecap="round"
      />
      <path d="M87.6482 79.8464L89.4594 83.8362" stroke="#FF967C" strokeWidth="0.55009" strokeLinecap="round" />
      <path d="M92.0491 81.1481C92.9695 82.4675 93.4628 84.0378 93.4623 85.6467" stroke="#FF967C" strokeWidth="0.55009" strokeLinecap="round" />
      <path d="M97.009 82.4587C97.009 82.4587 97.9208 84.5497 97.996 86.2033" stroke="#FF967C" strokeWidth="0.55009" strokeLinecap="round" />
      <path d="M101.07 83.9603C101.429 84.8426 101.569 85.7991 101.476 86.7473" stroke="#FF967C" strokeWidth="0.55009" strokeLinecap="round" />
      <path
        d="M71.3307 93.031C71.3307 93.031 72.4096 91.6609 72.0395 90.9737C71.6694 90.2865 70.0233 89.3147 69.0719 89.4204C68.6179 89.4889 68.1799 89.638 67.7787 89.8611C67.7057 89.8991 67.6441 89.9557 67.5998 90.0252C67.5555 90.0946 67.53 90.1742 67.5259 90.2565C67.522 90.3387 67.5394 90.4206 67.5768 90.4939C67.6142 90.5674 67.6701 90.6297 67.739 90.6748L71.3307 93.031Z"
        stroke="#FF967C"
        strokeWidth="0.55009"
        strokeLinecap="round"
      />
      <path
        d="M52.7785 109.737H19.9113C19.7757 109.74 19.6411 109.713 19.5165 109.659C19.3919 109.606 19.2804 109.526 19.1895 109.425C19.0985 109.324 19.0302 109.205 18.9892 109.076C18.9481 108.947 18.9354 108.81 18.9518 108.675L20.2424 95.2492C20.2745 94.9612 20.4103 94.6948 20.6244 94.4995C20.8385 94.3042 21.1162 94.1935 21.406 94.1877H54.2734C54.409 94.185 54.5436 94.2115 54.668 94.2654C54.7926 94.3191 54.9041 94.399 54.9952 94.4996C55.0861 94.6004 55.1543 94.7194 55.1955 94.8486C55.2364 94.9781 55.2492 95.1146 55.2329 95.2492L53.9423 108.675C53.91 108.963 53.7742 109.23 53.5601 109.425C53.3462 109.62 53.0683 109.731 52.7785 109.737Z"
        fill="#6BC2B4"
      />
      <path d="M22.9968 97.6891H43.2807" stroke="#5AA19F" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M22.9968 97.6891H37.0922" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M22.6934 101.962H42.9772" stroke="#5AA19F" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M22.6934 101.962H31.1205" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M22.03 106.236H42.3139" stroke="#5AA19F" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path d="M22.03 106.236H27.1836" stroke="white" strokeWidth="2.14348" stroke-miterlimit="10" strokeLinecap="round" />
      <path
        d="M50.4609 98.9008C51.1303 98.9008 51.6729 98.3582 51.6729 97.689C51.6729 97.0195 51.1303 96.4769 50.4609 96.4769C49.7916 96.4769 49.249 97.0195 49.249 97.689C49.249 98.3582 49.7916 98.9008 50.4609 98.9008Z"
        fill="white"
      />
      <path
        d="M50.0677 102.987C50.7372 102.987 51.2798 102.445 51.2798 101.775C51.2798 101.106 50.7372 100.563 50.0677 100.563C49.3983 100.563 48.8557 101.106 48.8557 101.775C48.8557 102.445 49.3983 102.987 50.0677 102.987Z"
        fill="white"
      />
      <path
        d="M49.629 107.448C50.2983 107.448 50.841 106.905 50.841 106.236C50.841 105.566 50.2983 105.024 49.629 105.024C48.9596 105.024 48.417 105.566 48.417 106.236C48.417 106.905 48.9596 107.448 49.629 107.448Z"
        fill="white"
      />
    </g>

    <defs>
      <linearGradient id="paint0_linear_28_237" x1="59.0542" y1="-15.2738" x2="102.121" y2="200.546" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#94B9FF" />
      </linearGradient>
      <linearGradient id="paint1_linear_28_237" x1="64.1404" y1="21.4276" x2="68.3162" y2="86.4316" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#94B9FF" />
      </linearGradient>
      <linearGradient id="paint2_linear_28_237" x1="76.5457" y1="54.7272" x2="83.3761" y2="111.286" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#94B9FF" />
      </linearGradient>
      <linearGradient id="paint3_linear_28_237" x1="61.8928" y1="83.4854" x2="63.0959" y2="116.798" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#94B9FF" />
      </linearGradient>
      <linearGradient id="paint4_linear_28_237" x1="114.18" y1="16.6367" x2="115.206" y2="30.0764" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#94B9FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const InviteIconAiplaneSvg = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clip-path="url(#clip0_28_317)">
      <path
        d="M14.8394 8.18116L5.88525 15.9529V19.757V23.5611L6.00676 23.72C6.24043 24.0285 6.66103 24.1126 6.9648 23.907C7.06294 23.8462 7.83871 22.8508 8.93228 21.3974C9.9277 20.0748 10.7455 18.9766 10.7455 18.9579C10.7455 18.9345 21.9662 3.04048 23.63 0.703802C23.7468 0.544909 23.8262 0.414055 23.8122 0.414055C23.7982 0.414055 19.7604 3.90972 14.8394 8.18116Z"
        fill="#9CB7D2"
      />
      <path
        d="M23.8497 0.329956C23.803 0.386036 23.789 0.414076 23.8263 0.390709C23.8637 0.367342 23.8404 0.423424 23.7749 0.512217C23.6254 0.708496 10.9232 18.6822 10.8157 18.8411L10.741 18.9579L14.7273 21.4114C16.9191 22.7574 18.7838 23.8976 18.8726 23.9444C19.1156 24.0659 19.4941 24.0238 19.6717 23.8509C19.854 23.6733 19.9194 23.4817 20.0877 22.5657C20.1671 22.1405 20.3914 20.9628 20.583 19.9487C20.7793 18.9346 21.0083 17.7242 21.0971 17.2615C21.1859 16.7988 21.4803 15.252 21.7514 13.8266C22.5505 9.65329 23.0739 6.89134 23.2235 6.11556C23.2983 5.71833 23.5413 4.45652 23.7609 3.31155C24.2142 0.960857 24.2516 0.685131 24.1441 0.479504C24.0226 0.245836 23.9525 0.213121 23.8497 0.329956Z"
        fill="white"
      />
      <path
        d="M23.5225 0.610367L23.387 0.764587L23.5412 0.62906C23.6206 0.549613 23.6907 0.484187 23.6907 0.47484C23.6907 0.437453 23.6533 0.470167 23.5225 0.610367Z"
        fill="white"
      />
      <path
        d="M23.1953 0.890762L23.0598 1.04498L23.214 0.909456C23.2935 0.830009 23.3636 0.764582 23.3636 0.755235C23.3636 0.717849 23.3262 0.750562 23.1953 0.890762Z"
        fill="white"
      />
      <path
        d="M22.8216 1.21791L22.686 1.37213L22.8403 1.2366C22.9197 1.15716 22.9898 1.09173 22.9898 1.08238C22.9898 1.045 22.9524 1.07771 22.8216 1.21791Z"
        fill="white"
      />
      <path
        d="M22.4709 1.52163L22.312 1.69922L22.4896 1.54032C22.5831 1.45153 22.6625 1.37208 22.6625 1.36274C22.6625 1.32535 22.6251 1.36274 22.4709 1.52163Z"
        fill="white"
      />
      <path
        d="M22.1204 1.82545L21.9849 1.97968L22.1391 1.84415C22.2185 1.7647 22.2886 1.69927 22.2886 1.68993C22.2886 1.65254 22.2512 1.68525 22.1204 1.82545Z"
        fill="white"
      />
      <path
        d="M21.7466 2.15254L21.6111 2.30676L21.7653 2.17124C21.8448 2.09179 21.9149 2.02636 21.9149 2.01702C21.9149 1.97963 21.8775 2.01234 21.7466 2.15254Z"
        fill="white"
      />
      <path
        d="M21.4195 2.43294L21.2839 2.58716L21.4382 2.45163C21.5176 2.37218 21.5877 2.30676 21.5877 2.29741C21.5877 2.26002 21.5503 2.29274 21.4195 2.43294Z"
        fill="white"
      />
      <path
        d="M21.0457 2.76009L20.9102 2.91431L21.0644 2.77878C21.1438 2.69933 21.2139 2.63391 21.2139 2.62456C21.2139 2.58717 21.1765 2.61989 21.0457 2.76009Z"
        fill="white"
      />
      <path
        d="M20.7185 3.04048L20.583 3.1947L20.7372 3.05918C20.8167 2.97973 20.8868 2.9143 20.8868 2.90495C20.8868 2.86757 20.8494 2.90028 20.7185 3.04048Z"
        fill="white"
      />
      <path
        d="M20.3445 3.36763L20.209 3.52185L20.3632 3.38632C20.4427 3.30688 20.5128 3.24145 20.5128 3.2321C20.5128 3.19472 20.4754 3.22743 20.3445 3.36763Z"
        fill="white"
      />
      <path
        d="M19.9941 3.67141L19.8352 3.849L20.0128 3.69011C20.1063 3.60131 20.1857 3.52186 20.1857 3.51252C20.1857 3.47513 20.1483 3.51252 19.9941 3.67141Z"
        fill="white"
      />
      <path
        d="M19.6436 3.97517L19.5081 4.12939L19.6623 3.99387C19.8025 3.86301 19.8352 3.82563 19.7978 3.82563C19.7885 3.82563 19.723 3.89573 19.6436 3.97517Z"
        fill="white"
      />
      <path
        d="M19.2698 4.30232L19.1343 4.45654L19.2885 4.32102C19.3679 4.24157 19.438 4.17614 19.438 4.1668C19.438 4.12941 19.4007 4.16212 19.2698 4.30232Z"
        fill="white"
      />
      <path
        d="M18.9427 4.58272L18.8071 4.73694L18.9613 4.60141C19.1015 4.47056 19.1343 4.43317 19.0969 4.43317C19.0875 4.43317 19.0221 4.50327 18.9427 4.58272Z"
        fill="white"
      />
      <path
        d="M18.5686 4.90987L18.4331 5.06409L18.5873 4.92856C18.6668 4.84911 18.7369 4.78369 18.7369 4.77434C18.7369 4.73695 18.6995 4.76967 18.5686 4.90987Z"
        fill="white"
      />
      <path
        d="M18.2182 5.21359L18.0593 5.39117L18.2369 5.23228C18.3304 5.14349 18.4098 5.06404 18.4098 5.05469C18.4098 5.01731 18.3724 5.05469 18.2182 5.21359Z"
        fill="white"
      />
      <path
        d="M17.8677 5.51735L17.7322 5.67157L17.8864 5.53604C17.9658 5.4566 18.0359 5.39117 18.0359 5.38182C18.0359 5.34444 17.9986 5.37715 17.8677 5.51735Z"
        fill="white"
      />
      <path
        d="M17.5173 5.82113L17.3584 5.99872L17.536 5.83982C17.6949 5.6856 17.7323 5.64822 17.6949 5.64822C17.6855 5.64822 17.6061 5.72766 17.5173 5.82113Z"
        fill="white"
      />
      <path
        d="M17.1668 6.12489L17.0312 6.27911L17.1855 6.14359C17.2649 6.06414 17.335 5.99871 17.335 5.98937C17.335 5.95198 17.2976 5.98469 17.1668 6.12489Z"
        fill="white"
      />
      <path
        d="M16.7928 6.45204L16.6572 6.60626L16.8114 6.47074C16.9516 6.33988 16.9844 6.30249 16.947 6.30249C16.9376 6.30249 16.8722 6.37259 16.7928 6.45204Z"
        fill="white"
      />
      <path
        d="M16.4656 6.73244L16.3301 6.88666L16.4843 6.75113C16.5637 6.67168 16.6338 6.60626 16.6338 6.59691C16.6338 6.55952 16.5965 6.59224 16.4656 6.73244Z"
        fill="white"
      />
      <path
        d="M16.0918 7.05959L15.9563 7.21381L16.1105 7.07828C16.19 6.99883 16.2601 6.93341 16.2601 6.92406C16.2601 6.88667 16.2227 6.91939 16.0918 7.05959Z"
        fill="white"
      />
      <path
        d="M15.7414 7.36337L15.5825 7.54095L15.7601 7.38206C15.8536 7.29327 15.933 7.21382 15.933 7.20447C15.933 7.16709 15.8956 7.20447 15.7414 7.36337Z"
        fill="white"
      />
      <path
        d="M15.3909 7.66713L15.2554 7.82135L15.4096 7.68582C15.5498 7.55497 15.5825 7.51758 15.5451 7.51758C15.5358 7.51758 15.4703 7.58768 15.3909 7.66713Z"
        fill="white"
      />
      <path
        d="M15.0402 7.97085L14.8813 8.14844L15.0589 7.98954C15.1524 7.90075 15.2318 7.8213 15.2318 7.81196C15.2318 7.77457 15.1945 7.81196 15.0402 7.97085Z"
        fill="white"
      />
      <path
        d="M14.6897 8.27467L14.5542 8.42889L14.7084 8.29337C14.8486 8.16251 14.8813 8.12513 14.8439 8.12513C14.8346 8.12513 14.7692 8.19523 14.6897 8.27467Z"
        fill="white"
      />
      <path
        d="M14.3159 8.60176L14.1804 8.75598L14.3346 8.62045C14.4748 8.4896 14.5076 8.45221 14.4702 8.45221C14.4608 8.45221 14.3954 8.52231 14.3159 8.60176Z"
        fill="white"
      />
      <path
        d="M13.9888 8.88216L13.8533 9.03638L14.0075 8.90085C14.0869 8.8214 14.157 8.75598 14.157 8.74663C14.157 8.70924 14.1197 8.74196 13.9888 8.88216Z"
        fill="white"
      />
      <path
        d="M13.615 9.2093L13.4795 9.36353L13.6337 9.228C13.7132 9.14855 13.7833 9.08312 13.7833 9.07378C13.7833 9.03639 13.7459 9.0691 13.615 9.2093Z"
        fill="white"
      />
      <path
        d="M13.2644 9.51309L13.1055 9.69067L13.2831 9.53178C13.3765 9.44299 13.456 9.36354 13.456 9.35419C13.456 9.31681 13.4186 9.35419 13.2644 9.51309Z"
        fill="white"
      />
      <path
        d="M12.9141 9.81685L12.7786 9.97107L12.9328 9.83554C13.073 9.70469 13.1057 9.6673 13.0683 9.6673C13.059 9.6673 12.9935 9.7374 12.9141 9.81685Z"
        fill="white"
      />
      <path
        d="M12.5401 10.144L12.4045 10.2982L12.5588 10.1627C12.6382 10.0832 12.7083 10.0178 12.7083 10.0085C12.7083 9.97108 12.6709 10.0038 12.5401 10.144Z"
        fill="white"
      />
      <path
        d="M12.2129 10.4244L12.0774 10.5786L12.2316 10.4431C12.3111 10.3636 12.3812 10.2982 12.3812 10.2889C12.3812 10.2515 12.3438 10.2842 12.2129 10.4244Z"
        fill="white"
      />
      <path
        d="M11.8391 10.7515L11.7036 10.9058L11.8578 10.7702C11.998 10.6394 12.0307 10.602 11.9934 10.602C11.984 10.602 11.9186 10.6721 11.8391 10.7515Z"
        fill="white"
      />
      <path
        d="M11.512 11.0319L11.3765 11.1862L11.5307 11.0506C11.6709 10.9198 11.7036 10.8824 11.6662 10.8824C11.6569 10.8824 11.5914 10.9525 11.512 11.0319Z"
        fill="white"
      />
      <path
        d="M11.1382 11.3591L11.0027 11.5133L11.1569 11.3778C11.2971 11.2469 11.3298 11.2095 11.2924 11.2095C11.2831 11.2095 11.2177 11.2796 11.1382 11.3591Z"
        fill="white"
      />
      <path
        d="M10.7876 11.6628L10.6287 11.8404L10.8062 11.6815C10.9651 11.5273 11.0025 11.4899 10.9651 11.4899C10.9558 11.4899 10.8763 11.5693 10.7876 11.6628Z"
        fill="white"
      />
      <path
        d="M10.437 11.9666L10.3015 12.1208L10.4557 11.9853C10.5959 11.8544 10.6286 11.817 10.5913 11.817C10.5819 11.817 10.5165 11.8871 10.437 11.9666Z"
        fill="white"
      />
      <path
        d="M10.0633 12.2937L9.92773 12.4479L10.082 12.3124C10.2222 12.1816 10.2549 12.1442 10.2175 12.1442C10.2081 12.1442 10.1427 12.2143 10.0633 12.2937Z"
        fill="white"
      />
      <path
        d="M9.73611 12.5741L9.60059 12.7283L9.75481 12.5928C9.89501 12.462 9.92772 12.4246 9.89033 12.4246C9.88099 12.4246 9.81556 12.4947 9.73611 12.5741Z"
        fill="white"
      />
      <path
        d="M9.36233 12.9013L9.22681 13.0555L9.38103 12.92C9.52123 12.7891 9.55394 12.7517 9.51655 12.7517C9.50721 12.7517 9.44178 12.8218 9.36233 12.9013Z"
        fill="white"
      />
      <path
        d="M9.03519 13.1817L8.89966 13.3359L9.05388 13.2003C9.19408 13.0695 9.22679 13.0321 9.18941 13.0321C9.18006 13.0321 9.11463 13.1022 9.03519 13.1817Z"
        fill="white"
      />
      <path
        d="M8.66116 13.5088L8.52563 13.663L8.67986 13.5275C8.7593 13.4481 8.8294 13.3826 8.8294 13.3733C8.8294 13.3359 8.79202 13.3686 8.66116 13.5088Z"
        fill="white"
      />
      <path
        d="M8.31075 13.8126L8.15186 13.9902L8.32944 13.8313C8.48834 13.6771 8.52572 13.6397 8.48834 13.6397C8.47899 13.6397 8.39954 13.7191 8.31075 13.8126Z"
        fill="white"
      />
      <path
        d="M7.96023 14.1163L7.82471 14.2706L7.97893 14.135C8.11913 14.0042 8.15184 13.9668 8.11445 13.9668C8.10511 13.9668 8.03968 14.0369 7.96023 14.1163Z"
        fill="white"
      />
      <path
        d="M7.58645 14.4434L7.45093 14.5977L7.60515 14.4621C7.74535 14.3313 7.77806 14.2939 7.74068 14.2939C7.73133 14.2939 7.6659 14.364 7.58645 14.4434Z"
        fill="white"
      />
      <path
        d="M7.25931 14.7239L7.12378 14.8781L7.278 14.7426C7.4182 14.6117 7.45091 14.5743 7.41353 14.5743C7.40418 14.5743 7.33875 14.6444 7.25931 14.7239Z"
        fill="white"
      />
      <path
        d="M6.88528 15.051L6.74976 15.2052L6.90398 15.0697C7.04418 14.9388 7.07689 14.9014 7.0395 14.9014C7.03016 14.9014 6.96473 14.9715 6.88528 15.051Z"
        fill="white"
      />
      <path
        d="M6.53487 15.3548L6.37598 15.5323L6.55356 15.3735C6.71246 15.2192 6.74984 15.1818 6.71246 15.1818C6.70311 15.1818 6.62366 15.2613 6.53487 15.3548Z"
        fill="white"
      />
      <path
        d="M6.18436 15.6585L6.04883 15.8127L6.20305 15.6772C6.2825 15.5978 6.3526 15.5323 6.3526 15.523C6.3526 15.4856 6.31521 15.5183 6.18436 15.6585Z"
        fill="white"
      />
      <path
        d="M21.9149 0.778575C21.1578 1.16179 16.8163 3.33957 12.2644 5.62484C-0.138649 11.8451 0.496927 11.5226 0.398786 11.6628C0.272606 11.8357 0.244566 12.2283 0.342706 12.4292C0.436173 12.6255 0.356726 12.5741 3.67013 14.607C5.28243 15.5978 5.8853 15.9436 5.91334 15.9015C5.9367 15.8688 9.96045 12.3731 14.8581 8.12508C19.7558 3.877 23.8029 0.362647 23.8543 0.315913C23.9852 0.189733 23.8917 0.119633 23.5646 0.0962658C23.2935 0.0822458 23.2842 0.0869188 21.9149 0.778575Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_28_317">
        <rect width="23.9275" height="23.9275" fill="white" transform="translate(0.277344 0.0869141)" />
      </clipPath>
    </defs>
  </svg>
);

export const AddMembersIconSvg = ({ className, color = "#fff" }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill = {color}>
  <path d="M14.1342 16.812C14.2018 16.9157 14.2402 17.0358 14.2453 17.1595C14.2503 17.2832 14.2218 17.406 14.1628 17.5149C14.1039 17.6238 14.0166 17.7148 13.9102 17.7781C13.8038 17.8415 13.6822 17.875 13.5584 17.875H0.879189C0.755349 17.875 0.633813 17.8415 0.527421 17.7781C0.421028 17.7148 0.333731 17.6238 0.274751 17.5149C0.215771 17.406 0.187299 17.2832 0.192343 17.1595C0.197387 17.0358 0.23576 16.9157 0.303407 16.812C1.27115 15.3223 2.69461 14.1856 4.36138 13.5712C3.43995 12.9578 2.7404 12.0641 2.36616 11.0224C1.99193 9.98063 1.96288 8.84609 2.28331 7.78654C2.60375 6.72699 3.25665 5.79869 4.14548 5.13891C5.0343 4.47914 6.11186 4.12291 7.2188 4.12291C8.32574 4.12291 9.40329 4.47914 10.2921 5.13891C11.1809 5.79869 11.8338 6.72699 12.1543 7.78654C12.4747 8.84609 12.4457 9.98063 12.0714 11.0224C11.6972 12.0641 10.9976 12.9578 10.0762 13.5712C11.743 14.1856 13.1664 15.3223 14.1342 16.812ZM21.689 16.7991C20.7209 15.3157 19.3007 14.1838 17.6387 13.5712C18.7265 12.8385 19.4942 11.7188 19.7855 10.44C20.0768 9.16119 19.8698 7.81944 19.2067 6.68785C18.5437 5.55626 17.4743 4.71989 16.2162 4.34898C14.9582 3.97806 13.6061 4.10049 12.4352 4.69133C12.3904 4.71445 12.3513 4.74713 12.3205 4.78705C12.2898 4.82698 12.2682 4.87318 12.2573 4.92237C12.2464 4.97157 12.2464 5.02256 12.2574 5.07174C12.2684 5.12092 12.2901 5.16708 12.3209 5.20695C13.1916 6.29304 13.6916 7.62939 13.7478 9.02027C13.8039 10.4111 13.4132 11.7834 12.6329 12.9362C12.5824 13.0115 12.5638 13.1037 12.581 13.1927C12.5982 13.2817 12.6499 13.3603 12.7248 13.4114C13.7422 14.1215 14.6132 15.0211 15.29 16.0609C15.563 16.4789 15.6745 16.982 15.6037 17.4762C15.5958 17.5254 15.5986 17.5757 15.612 17.6237C15.6253 17.6717 15.649 17.7162 15.6813 17.7541C15.7136 17.792 15.7537 17.8225 15.7989 17.8433C15.8442 17.8642 15.8934 17.875 15.9432 17.875H21.1252C21.2766 17.875 21.4238 17.8251 21.5439 17.733C21.664 17.6408 21.7503 17.5116 21.7895 17.3654C21.8134 17.2692 21.8168 17.1691 21.7995 17.0715C21.7822 16.974 21.7445 16.8811 21.689 16.7991Z" />
</svg>
  );

export const AddServicesIconSvg = ({ className, color = "#fff" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M19.4 8.95476C19.0208 8.03436 18.475 7.20024 17.8 6.49C16.3424 4.95622 14.2829 4 12 4C7.58172 4 4 7.58172 4 12H8L10 15.2L13.6 8L16.4 12H20C20 16.4183 16.4183 20 12 20C9.81964 20 7.843 19.1278 6.4 17.7132C5.6719 16.9994 5.07967 16.1475 4.66567 15.2"
      stroke= {color}
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const OnboardingModalCloseButtonSvg = ({className}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M16.115 0.377526C15.9994 0.261646 15.862 0.169712 15.7108 0.106985C15.5596 0.0442581 15.3975 0.0119704 15.2338 0.0119704C15.0701 0.0119704 14.908 0.0442581 14.7567 0.106985C14.6055 0.169712 14.4682 0.261646 14.3525 0.377526L8.24002 6.47753L2.12753 0.365025C2.0118 0.249298 1.87441 0.157498 1.7232 0.0948667C1.572 0.0322355 1.40994 1.21939e-09 1.24628 0C1.08261 -1.21939e-09 0.920551 0.0322355 0.769346 0.0948667C0.618141 0.157498 0.480753 0.249298 0.365025 0.365025C0.249298 0.480753 0.157498 0.618141 0.0948667 0.769346C0.0322355 0.920551 -1.21939e-09 1.08261 0 1.24628C1.21939e-09 1.40994 0.0322355 1.572 0.0948667 1.7232C0.157498 1.87441 0.249298 2.0118 0.365025 2.12753L6.47753 8.24002L0.365025 14.3525C0.249298 14.4683 0.157498 14.6056 0.0948667 14.7568C0.0322355 14.9081 0 15.0701 0 15.2338C0 15.3974 0.0322355 15.5595 0.0948667 15.7107C0.157498 15.8619 0.249298 15.9993 0.365025 16.115C0.480753 16.2307 0.618141 16.3225 0.769346 16.3852C0.920551 16.4478 1.08261 16.48 1.24628 16.48C1.40994 16.48 1.572 16.4478 1.7232 16.3852C1.87441 16.3225 2.0118 16.2307 2.12753 16.115L8.24002 10.0025L14.3525 16.115C14.4683 16.2307 14.6056 16.3225 14.7568 16.3852C14.9081 16.4478 15.0701 16.48 15.2338 16.48C15.3974 16.48 15.5595 16.4478 15.7107 16.3852C15.8619 16.3225 15.9993 16.2307 16.115 16.115C16.2307 15.9993 16.3225 15.8619 16.3852 15.7107C16.4478 15.5595 16.48 15.3974 16.48 15.2338C16.48 15.0701 16.4478 14.9081 16.3852 14.7568C16.3225 14.6056 16.2307 14.4683 16.115 14.3525L10.0025 8.24002L16.115 2.12753C16.59 1.65253 16.59 0.852526 16.115 0.377526Z"
      fill="#B4B9BD"
    />
  </svg>
);
